'use client';
import { event_button_click } from '@/utils/gtm';

import CategoryFixedIcon from '@/components/ui/icons/category-fixed-icon';
import UploadFixedIcon from '@/components/ui/icons/upload-fixed-icon';
import HomeFixedIcon from '@/components/ui/icons/home-fixed-icon';
import { usePathname, useRouter } from '@/i18n/navigation';
import CartIcon from '@/components/ui/icons/CartIcon';
import { useSession } from 'next-auth/react';
import useCart from '@/store/cart.store';
import { useLocale } from 'next-intl';
import CrownIcon from '@/components/ui/icons/crown';

export const FixedBox = ({ categoriesUrl }) => {
  const pathname = usePathname();
  const { push } = useRouter();
  const locale = useLocale();
  const { data: session } = useSession();
  const cart = useCart((state) => state);

  const isProductPage = pathname.includes('/product');

  if (pathname === '/checkout') return null;

  return (
    <div
      className={`fixed start-0 bottom-0 z-48 hidden w-screen grid-cols-5 gap-2 border-t border-gray-200 bg-white px-2 py-2.5 max-lg:grid ${isProductPage && 'max-md:shadow-[0_-6px_20px_rgba(2,6,23,0.06)]'}`}
    >
      <button
        onClick={() => {
          event_button_click({
            button_name: 'Home',
            button_destination: '/',
            button_location: 'bottom_nav',
          });
          push('/');
        }}
        className={`${pathname === '/' ? 'text-primary' : 'text-tertiary-600'} relative flex flex-col items-center justify-center gap-0.5`}
      >
        <HomeFixedIcon className='size-4.5 sm:size-5' />
        <span className='line-clamp-1 text-center text-[10px] font-semibold sm:text-xs'>
          {locale === 'en' ? 'Home' : 'الرئيسية'}
        </span>
        <span
          className={`bg-primary h-.05 absolute -bottom-0.5 w-6 origin-center rounded duration-200 ease-in ${pathname === '/' ? 'scale-x-[1]' : 'scale-x-0'}`}
        />
      </button>
      <button
        onClick={() => {
          event_button_click({
            button_name: 'Categories',
            button_destination: '/categories',
            button_location: 'bottom_nav',
          });
          push('/categories');
        }}
        className={`${pathname === '/categories' ? 'text-primary' : 'text-tertiary-600'} relative flex flex-col items-center justify-center gap-0.5`}
      >
        <CategoryFixedIcon className='size-4.5 sm:size-5' />
        <span className='line-clamp-1 text-center text-[10px] font-semibold sm:text-xs'>
          {locale === 'en' ? 'Categories' : 'الفئات'}
        </span>
        <span
          className={`bg-primary h-.05 absolute -bottom-0.5 w-6 origin-center rounded duration-200 ease-in ${pathname === '/categories' ? 'scale-x-[1]' : 'scale-x-0'}`}
        />
      </button>
      <button
        onClick={() => {
          const destination = !session?.user ? '/login' : '/prescription';
          event_button_click({
            button_name: 'Prescription',
            button_destination: destination,
            button_location: 'bottom_nav',
          });
          push(destination);
        }}
        className={`${pathname === '/prescription' ? 'text-primary' : 'text-tertiary-600'} relative flex flex-col items-center justify-center gap-0.5`}
      >
        <UploadFixedIcon className='size-4.5 sm:size-5' />
        <span className='line-clamp-1 text-center text-[10px] font-semibold sm:text-xs'>
          {locale === 'en' ? 'Prescription' : 'الوصفة الطبية'}
        </span>
        <span
          className={`bg-primary absolute -bottom-0.5 h-0.5 w-6 origin-center rounded duration-200 ease-in ${pathname === '/prescription' ? 'scale-x-[1]' : 'scale-x-0'}`}
        />
      </button>
      <button
        onClick={() => {
          event_button_click({
            button_name: 'Offers',
            button_destination: categoriesUrl?.value?.[0]?.url,
            button_location: 'bottom_nav',
          });
          push(categoriesUrl?.value?.[0]?.url);
        }}
        className={`${pathname.includes(categoriesUrl?.value?.[0]?.url) ? 'text-primary' : 'text-tertiary-600'} relative flex flex-col items-center justify-center gap-0.5`}
      >
        <CrownIcon className='size-4.5 sm:size-5' />
        <span className='line-clamp-1 text-center text-[10px] font-semibold sm:text-xs'>
          {locale === 'en' ? 'Offers' : 'العروض'}
        </span>
        <span
          className={`bg-primary absolute -bottom-0.5 h-0.5 w-6 origin-center rounded duration-200 ease-in ${pathname.includes(categoriesUrl?.value?.[0]?.url) ? 'scale-x-[1]' : 'scale-x-0'}`}
        />
      </button>
      <button
        onClick={() => {
          event_button_click({
            button_name: 'Cart',
            button_destination: '/cart',
            button_location: 'bottom_nav',
          });
          push('/cart');
        }}
        className={`${pathname === '/cart' ? 'text-primary' : 'text-tertiary-600'} relative flex flex-col items-center justify-center gap-0.5`}
      >
        <span className='relative'>
          <CartIcon className='size-4.5 sm:size-5' />
          {cart?.cartItems?.length > 0 ? (
            <span className='bg-primary absolute -end-1 -top-2 z-20 flex size-3.5 items-center justify-center rounded-full text-xs text-white'>
              {cart?.cartItems?.length}
            </span>
          ) : null}
        </span>
        <span className='line-clamp-1 text-center text-[10px] font-semibold sm:text-xs'>
          {locale === 'en' ? 'Cart' : 'السلة'}
        </span>
        <span
          className={`bg-primary absolute -bottom-0.5 h-0.5 w-6 origin-center rounded duration-200 ease-in ${pathname === '/cart' ? 'scale-x-[1]' : 'scale-x-0'}`}
        />
      </button>
    </div>
  );
};
